import { decodeBase58 } from "./base58";

const PUBLIC_KEY_BYTES = 32;

/**
 * A Solana address is a 32-byte public key written in base58. This checks the form only:
 * it cannot know who holds the key, which is why the address comes from Oliver and is
 * shown to the visitor in full to check against their wallet.
 */
export function isSolanaAddress(text: string): boolean {
  return decodeBase58(text)?.length === PUBLIC_KEY_BYTES;
}

/** A Solana Pay transfer request: wallets that scan it open a send screen to this address. */
export function solanaPayUrl(address: string, label: string): string {
  if (!isSolanaAddress(address)) throw new Error("Not a Solana address");
  return `solana:${address}?label=${encodeURIComponent(label)}`;
}
